export default {
  company:"Snow Electronics(HK) Limited",
 router: {
    homePage:"HOME",
    news:"NEWS",
    product:"PRODUCT",
    cooperation:"Brand",
    contact:"CONTACT",
    about:"ABOUT"
  },
  home:{
    placeholder:"Please enter the product",
    news:"Latest News",
    companyTitle:"About",
    honors:"Company Honors",
    classification:"classification",
    NewsList:"News List",
    prodDetails:"Product Details",

    city:"Shenzhen",
      add:'Rm.817,DynamicWorld Building,Zhonghang Rd.,Futian District,Shenzhen.',
      tel:'Tel',
      fax:"FAX",
      contact:"contact：CAI Hongchang 13723766003",
      email:"MAIL"

  },
  detailList:{
    image:"image",
    name:"name",
    classifiy:"Category",
    details:'description'
  },
  intoduction:{
    Number:"Number:",
    Specif:"Specif:",
    Category:"Category:",
    Hotline:"Hotline:",

    detail:"Details",
    Related:"Related products",

    order:"Order:",
    name:"Name:",
    phone:"Phone:",
    email:'Email:',
    description:"Please fill in the order of product quantity and product description, ready for the convenience we undertake unity!",
    submit:"Submit",
  },
  footer:{
    Copyright:"Snow Electronics(HK) Limited All rights reserved",
    add:"ADD：Rm.817,DynamicWorld Building,Zhonghang Rd.,Futian District,Shenzhen.",
    tel:"TEL：0755-82543095",
    icp:"ICP：粤ICP备14010311号-1",
    it:"IT Support：7inc"
  }

}